<our-initiative-photo-slides></our-initiative-photo-slides>
<the-initiative></the-initiative>
<section id="atomo-at-work" class="px-4 md:px-14 lg:px-[108px] py-4 md:py-5">
  <atomo-at-work></atomo-at-work>
</section>
<number-in-initiatives></number-in-initiatives>
<initiative-partners></initiative-partners>
<initiative-media></initiative-media>
